import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ScrollText, Loader2 } from "lucide-react";
import { format } from "date-fns";

export default function AdminAuditoria() {
  const { data: logs, isLoading } = useQuery({
    queryKey: ["admin_audit_logs"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("partner_audit_logs")
        .select("*, partner_orgs(name)")
        .order("created_at", { ascending: false })
        .limit(100);
      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return <div className="p-8 flex items-center justify-center min-h-[50vh]"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;
  }

  return (
    <div className="p-8 max-w-6xl">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="font-heading text-2xl font-bold text-foreground">Auditoria</h1>
        <p className="text-muted-foreground text-sm mt-1">Últimas {(logs ?? []).length} ações registradas</p>
      </motion.div>

      <div className="mt-6 space-y-2">
        {(logs ?? []).map((log, i) => (
          <motion.div key={log.id} initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.02 * i }}
            className="bg-card rounded-xl p-4 border border-border flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground font-medium">{log.action}</p>
              <p className="text-xs text-muted-foreground">
                {(log.partner_orgs as any)?.name ?? "Sistema"} • {log.entity_type ?? ""} {log.entity_id ? `#${log.entity_id.slice(0, 8)}` : ""}
              </p>
            </div>
            <p className="text-xs text-muted-foreground shrink-0">{format(new Date(log.created_at), "dd/MM HH:mm")}</p>
          </motion.div>
        ))}
        {(logs ?? []).length === 0 && (
          <div className="bg-muted/50 rounded-2xl p-12 text-center">
            <ScrollText className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="font-heading font-semibold text-foreground mb-2">Nenhum log de auditoria</h3>
          </div>
        )}
      </div>
    </div>
  );
}
